jQuery(document).ajaxComplete(() => {
    const $ = jQuery.noConflict();
    $('[data-day-overview]:not(.init)').each(function() {
        const elm = $(this);
        elm.addClass('init');
        elm.append('<div class="day-container"><div class="time-grid"></div><div class="events-grid"></div></div>');

        for (let i = 0; i < (24 * 2); i++) {
            elm.find('.time-grid').append('<div></div>');
        }

        const fieldset = elm.find('.new-form-fieldset');
        elm[0]['new_form'] = fieldset.clone(true);
        fieldset.hide();

        elm.setAppointment('start_time=21%3A00&end_time=22%3A20&employer=1&id=1&name=%3Cspan+title%3D%22Testbedrijf+X%22%3ETestbedrijf+X%3C%2Fspan%3E&contract=Kantoor+1+%2F+Blussers&city=Dronten');
        elm.setAppointment('start_time=20%3A00&end_time=22%3A20&employer=1&id=1&name=%3Cspan+title%3D%22Testbedrijf+X%22%3ETestbedrijf+X%3C%2Fspan%3E&contract=Kantoor+1+%2F+Blussers&city=Dronten');
        elm.setAppointment('start_time=18%3A00&end_time=21%3A20&employer=1&id=1&name=%3Cspan+title%3D%22Testbedrijf+X%22%3ETestbedrijf+X%3C%2Fspan%3E&contract=Kantoor+1+%2F+Blussers&city=Dronten');
    });
});


(function ( $ ) {
    $.fn.setNewAppointmentForm = function(callback) {
        if (this.parent().hasClass('time-grid')) {
            const form = this.parents('[data-day-overview]').getNewAppointmentForm();

            const elm = this;

            elm.prepend(form);
            callback(form);
        }
        return this;
    };

}( jQuery ));

(function ( $ ) {
    $.fn.getNewAppointmentForm = function() {
        if (this[0]['new_form'] != undefined) {
            return this[0]['new_form'].clone(true);
        }
        if (this.parent().hasClass('time-grid')) {
            return this.parents('[data-day-overview]').getNewAppointmentForm();
        }
        return undefined;
    };

}( jQuery ));